import { Withdrawal } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import { getWithdrawalCompany, getWithdrawalUserName } from '../helpers'
import {
  CustomHeaderText,
  WithdrawalDateColumn,
  WithdrawalListMovileView,
  WithdrawalActionsColumn,
  WithdrawalStatusColumn,
  WithdrawalUserColumn,
  WithdrawalCompanyColumn,
  WithdrawalTotalColumn,
} from 'src/components'

const withdrawalListColumns: ColumnsType<Withdrawal> = [
  /* Withdrawal Data */

  {
    title: () => <CustomHeaderText text='Withdrawals.CreatedDate' />,
    responsive: ['sm'],
    sorter: (a: Withdrawal, b: Withdrawal) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, withdrawal) => <WithdrawalDateColumn withdrawal={withdrawal} />
  },
  {
    title: () => <CustomHeaderText text='Deposits.Total' />,
    responsive: ['sm'],
    sorter: (a: Withdrawal, b: Withdrawal) => a.total - b.total,
    render: (_, withdrawal) => <WithdrawalTotalColumn withdrawal={withdrawal} />
  },
  {
    title: () => <CustomHeaderText text='developers.User' />,
    responsive: ['sm'],
    sorter: (a: Withdrawal, b: Withdrawal) => {
      return getWithdrawalUserName(a)?.length - getWithdrawalUserName(b)?.length
    },
    render: (_, withdrawal) => <WithdrawalUserColumn withdrawal={withdrawal} />
  },
  {
    title: () => <CustomHeaderText text='menuItems.Company' isCentered />,
    responsive: ['sm'],
    sorter: (a: Withdrawal, b: Withdrawal) => {
      return getWithdrawalCompany(a)?.length - getWithdrawalCompany(b)?.length
    },
    render: (_, withdrawal) => <WithdrawalCompanyColumn withdrawal={withdrawal} />
  },
  {
    title: () => <CustomHeaderText text='Deposits.Status' isCentered />,
    responsive: ['sm'],
    render: (_, withdrawal) => <WithdrawalStatusColumn withdrawal={withdrawal} />
  },

  /* Actions */
  {
    title: () => <CustomHeaderText text='Deposits.Actions' isCentered />,
    responsive: ['sm'],
    render: (_, withdrawal) => <WithdrawalActionsColumn withdrawal={withdrawal} />
  },

  /* Mobile View */
  {
    title: () => <CustomHeaderText text='Withdrawals.Withdrawal' isCentered />,
    responsive: ['xs'],
    sorter: (a: Withdrawal, b: Withdrawal) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, withdrawal) => <WithdrawalListMovileView withdrawal={withdrawal} />
  },
]

export default withdrawalListColumns
